import { Outlet } from 'react-router-dom'

import { AppSidebar } from '@/app/layout/AppSidebar'
import { ReportErrorsBanner } from '@/app/layout/ReportErrorsBanner'
import { Topbar } from '@/app/layout/Topbar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { useRealtimeBridge } from '@/hooks/use-realtime'

/** Korumalı rotaların ortak iskeleti (sidebar-16): tam genişlik üst çubuk, altında kenar menü + içerik. */
export function AppShell() {
  useRealtimeBridge(true)

  return (
    <SidebarProvider
      // SidebarProvider durumu `sidebar_state` çerezine yazar; çerez yoksa açık başlar.
      defaultOpen={!document.cookie.includes('sidebar_state=false')}
      style={{ '--header-height': '3rem' } as React.CSSProperties}
      // İçerik genişliği animasyonsuz değişir, yalnız menü kayar: genişlik animasyonu büyük
      // tabloları (/tonaj 418 satır) her karede yeniden dizip ~20 ms/kare kasıyordu.
      className="bg-background text-foreground flex h-dvh min-h-0 w-full flex-col overflow-hidden [&_[data-slot=sidebar-gap]]:transition-none"
    >
      <Topbar />
      <div className="flex min-h-0 flex-1">
        <AppSidebar />
        <SidebarInset className="min-h-0 min-w-0 overflow-hidden">
          <main className="min-h-0 flex-1 overflow-y-auto p-4">
            <ReportErrorsBanner />
            <Outlet />
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  )
}
